import React, { useEffect, useState } from "react";
import Routes from "modules/Routes/Routes";
import Navbar from "modules/Navbar/Navbar";
import SideBar from "modules/SideBar/SideBar";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { uiActions } from "store/uiSlice";

function General() {
  const { pathname } = useLocation();
  const { show } = useSelector((state) => state.ui);
  const dispatch = useDispatch();
  const notHaveNavSide = ["/"];
  const pagesHaveSearchInNavbar = [
    "/movies",
    "/tv-shows",
    "/anime",
    "/tv-programs",
    "/fun-store",
  ];

  return (
    <section className={"general-section "}>
      {!notHaveNavSide.includes(pathname) && (
        <>
          <button
            type="primary"
            className="toggler-btn"
            onClick={() => dispatch(uiActions.toggleSidebar())}
            style={{
              left: show ? "320px" : "10px",
              transition: "left 0.3s ease",
            }}
          >
            {show ? <LeftOutlined /> : <RightOutlined />}
          </button>
          <div
            className={`${
              notHaveNavSide.includes(pathname) ? "d-none" : "side-bar"
            }`}
            style={{
              width: show ? "340px" : "20px",
              transition: "width 0.3s ease",
            }}
          >
            <SideBar />
          </div>
        </>
      )}
      <div
        className={`${
          notHaveNavSide.includes(pathname) ? "wd-100" : "all-content"
        }`}
        style={{
          width: show ? "calc(100% - 340px)" : "100%",
          margin: "0 auto",
        }}
      >
        {!notHaveNavSide.includes(pathname) && (
          <div className="nav-bar">
            <Navbar
              withSearch={
                pagesHaveSearchInNavbar.includes(pathname) ? true : false
              }
            />
          </div>
        )}
        <div className="component-wrapper">
          <div className="component ">
            <Routes />
          </div>
        </div>
      </div>
    </section>
  );
}

export default General;
